import React, { Component } from 'react';
import { PageHeader } from 'react-bootstrap';
import firebase from 'firebase';

class Settings extends Component {
  render() {
    return (
      <div>
        <PageHeader>Settings</PageHeader>
        <pre>{JSON.stringify(firebase.auth().currentUser, null, 2)}</pre>
      </div>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/pages/Settings/index.js